import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const SalesforceImportCustomersResponseSchema = oz.array(
  oz.object({
    crmId: ObjectIdSchema.optional().nullable(),
    name: oz.string(),
  }),
).openapi('salesforceImportCustomersResponseSchema');

export type SalesforceImportCustomersResponse = oz.infer<typeof SalesforceImportCustomersResponseSchema>;